var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 6.2998C8.19961 6.2998 4.89961 8.6998 3.59961 11.9998C4.89961 15.3998 8.19961 17.6998 11.9996 17.6998C15.7996 17.6998 19.0996 15.2998 20.3996 11.9998C19.0996 8.5998 15.7996 6.2998 11.9996 6.2998ZM11.9996 15.7998C9.89961 15.7998 8.19961 14.0998 8.19961 11.9998C8.19961 9.8998 9.89961 8.1998 11.9996 8.1998C14.0996 8.1998 15.7996 9.8998 15.7996 11.9998C15.7996 14.0998 14.0996 15.7998 11.9996 15.7998ZM11.9996 9.6998C10.6996 9.6998 9.69961 10.6998 9.69961 11.9998C9.69961 13.2998 10.6996 14.2998 11.9996 14.2998C13.2996 14.2998 14.2996 13.2998 14.2996 11.9998C14.2996 10.6998 13.2996 9.6998 11.9996 9.6998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.87ae1ce91578c13bd0c8fbf234e25ca8.svg";
export { ForwardRef as ReactComponent };